import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormFieldBaseComponent } from './components/base/form-field-base.component';
import { FormFieldFormlyComponent } from './components/formly/form-field-formly.component';

@NgModule({
  imports: [CommonModule],
  declarations: [FormFieldFormlyComponent, FormFieldBaseComponent],
  exports: [FormFieldFormlyComponent, FormFieldBaseComponent],
})
export class FormFieldModule {}
